import { render, staticRenderFns } from "./PurE.vue?vue&type=template&id=0c908355"
import script from "./PurE.vue?vue&type=script&lang=js"
export * from "./PurE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports